import React from "react";
import styled from "styled-components";
import WorkPageFold1 from "../components/WorkPageComponents/WorkPageFold1";
import { WorkPageFold2 } from "../components/WorkPageComponents/WorkPageFold2";
import { WorkPageFold3 } from "../components/WorkPageComponents/WorkPageFold3";
import RulesFold from "../components/WorkPageComponents/RulesFold";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const ApproachPage = () => {
  return (
    <>
      <Helmet>
        <title>
          Our Approach to Building Better Products, Faster | appssemble
        </title>
        <meta
          name="description"
          content="Learn how appssemble delivers better products, faster—through 4–6 week cycles, small self-sufficient teams, and a no-meeting, async-first culture."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="Our Approach to Building Better Products, Faster | appssemble"
        />
        <meta
          property="og:description"
          content="We work in small teams, avoid meetings, and take full ownership of what we ship. Explore our delivery philosophy and why it works."
        />
        <meta property="og:url" content="https://appssemble.com/approach" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Our Approach to Building Better Products, Faster | appssemble"
        />
        <meta
          name="twitter:description"
          content="No bloated teams, no hand-offs, no chaos. Just focused work, accountability, and better digital products. See how we deliver faster."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com/approach" />
      </Helmet>
      <WorkPageWrapper>
        <WorkPageFold1 />
        <WorkPageFold2 />
        <WorkPageFold3 />
        <RulesFold />
        <TrackingComponent />
      </WorkPageWrapper>
    </>
  );
};

export default ApproachPage;
const WorkPageWrapper = styled.div`
  min-height: 100vh;
`;
